import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { productPropTypes, routerPropTypes } from 'Types'
import { skin, getSearchTerm } from 'Utils'
import { withRouter } from 'react-router'
import { StoreProductsResponse } from '../..'
import { Dialog, AppliedFilters, ItemsFound } from 'Blocks'
import ProductList from '../../ProductList'
import { Search } from '../components'
import skins from '../skins'
import { PAGE_CONTEXT as p } from 'Constants'
import { PanelTrigger } from '../../Large/components'
import NoSearch from '../../NoSearch'
import config from 'Config'

const pageName = p.PRODUCT_LIST

class Small extends React.Component {
  render() {
    const {
      dialog,
      closeDialog,
      className,
      location,
      data,
      showOnlyProductList
    } = this.props
    const isSearch = this.props.match.params.subCategory === 'search'
    const { activeView: activeDialogView, isActive: isDialogOpen } = dialog
    const { search: queryString } = location

    const heading = (() => {
      const term = getSearchTerm({ location })

      if (isSearch && data.products.length === 0) {
        return <h1 className="heading">Nothing found for: {`${term}`}</h1>
      } else if (isSearch) {
        return (
          <Fragment>
            <div className="heading-term">
              {config.searchResults.label
                ? config.searchResults.label
                : 'Your search results for:'}{' '}
            </div>
            <h1 className="heading search-term">{`${term}`}</h1>
          </Fragment>
        )
      } else {
        return (
          <h1 className="heading">{data.products.categories.current.name}</h1>
        )
      }
    })()

    const noSearchProps = {
      ...this.props,
      className: ''
    }

    if (isSearch && data.products.products.length === 0) {
      return <NoSearch {...noSearchProps} />
    }
    if (showOnlyProductList) return <ProductList {...this.props} {...data} />
    return (
      <div className={`${className}${isDialogOpen ? ' no-scroll' : ''}`}>
        <Dialog shouldRender={isDialogOpen} activeView={activeDialogView}>
          {isDialogOpen && activeDialogView === 'search' && (
            <Search {...{ closeDialog }} />
          )}
        </Dialog>
        {heading}
        <StoreProductsResponse data={data} location={this.props.location} />
        <PanelTrigger queryString={queryString} />
        <ItemsFound />
        <AppliedFilters pageName={pageName} />
        <ProductList {...this.props} {...data} />
      </div>
    )
  }
}

Small.propTypes = {
  className: PropTypes.string,
  closeDialog: PropTypes.any,
  data: PropTypes.shape({
    products: PropTypes.shape({
      categories: PropTypes.shape({
        current: PropTypes.shape({
          name: PropTypes.any
        })
      }),
      length: PropTypes.number,
      products: PropTypes.arrayOf(PropTypes.shape({ ...productPropTypes }))
    })
  }),
  dialog: PropTypes.shape({
    activeView: PropTypes.string,
    isActive: PropTypes.any
  }),
  ...routerPropTypes
}

export default withRouter(skin(Small, skins))
